import { FadeUp, SectionHead } from "@/components/Reveal";

const POSTS = [
    {
        img: "/img/urwan/2J7A0639.jpg",
        date: "June 30, 2026",
        title: "The Art of Slow Denim",
        excerpt: "Why we wash less, weave tighter, and build jeans meant to outlive trends.",
    },
    {
        img: "/img/urwan/2J7A0775.jpg",
        date: "June 30, 2026",
        title: "Caring for Selvedge, the URWAN Way",
        excerpt: "A field guide to aging raw denim gracefully — from first wear to fade.",
    },
    {
        img: "/img/urwan/DSC00629.jpg",
        date: "June 30, 2026",
        title: "One Wardrobe, Three Lives",
        excerpt: "Work, weekend, after dark — the philosophy behind every URWAN silhouette.",
    },
];

export default function JournalSection() {
    return (
        <section className="border-y border-white/10 bg-coal/40 py-24 md:py-32">
            <div className="mx-auto w-full max-w-[1400px] px-5 md:px-8 lg:px-10">
                <SectionHead eyebrow="The URWAN Journal" title="Notes on Craft & Denim" align="center" />
                <div className="mt-14 grid gap-8 md:grid-cols-3">
                    {POSTS.map((post, i) => (
                        <FadeUp key={post.title} delay={i * 0.1}>
                            <article className="group" data-testid={`journal-card-${i + 1}`}>
                                <div className="aspect-[4/3] overflow-hidden bg-elev">
                                    <img
                                        src={post.img}
                                        alt={post.title}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                                    />
                                </div>
                                <p className="mt-5 text-[10px] font-mono uppercase tracking-[0.25em] text-mute">
                                    {post.date}
                                </p>
                                <h3 className="mt-2 font-display text-xl font-bold leading-snug text-ink transition-colors duration-300 group-hover:text-gold">
                                    {post.title}
                                </h3>
                                <p className="mt-2 text-sm leading-relaxed text-mute">{post.excerpt}</p>
                            </article>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
